import React from "react";
import display_types from "../../config/display_types";
import calculateAge from "../../utils/helpers/CalculateAge";

export function SubjectDemographicsTable({ subject, displayType, ...props }) {
  const formatHeight = (inches) => {
    if (inches === null || inches === undefined || isNaN(inches)) return "";
    const feet = Math.floor(inches / 12);
    const remainingInches = inches % 12;
    return `${feet}'${remainingInches}"`;
  };

  // Prepare demographic values
  const dob = subject ? subject.dob : "";
  const age = displayType === display_types.PHI ? (subject ? calculateAge(subject.dob) : "") : subject ? subject.age : "";
  const height = subject ? formatHeight(subject.height) : "";
  const weight = subject ? subject.weight : "";
  const sex = subject ? subject.sex : "";

  return (
    <>
      <div className="card-body">
        <div className="row">
          {/* Left Column - Demographics */}
          <div className="col-md-3">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="table-secondary">
                  <tr>
                    <th colspan="2">Demographics</th>
                  </tr>
                </thead>
                <tbody>
                  {displayType === display_types.PHI && (
                    <tr>
                      <td>
                        <strong>Date of Birth:</strong>
                      </td>
                      <td>{dob}</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <strong>Age:</strong>
                    </td>
                    <td>{age}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Height:</strong>
                    </td>
                    <td>{height}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Weight:</strong>
                    </td>
                    <td>{weight}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Sex:</strong>
                    </td>
                    <td>{sex}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Right Column - Tables */}
          <div className="col-md-9">
            {/* Primary Conditions Table (without header) */}
            <div className="table-responsive mb-4">
              <table className="table table-bordered">
                <thead className="table-secondary">
                  <tr>
                    <th>ICD-10-CM</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {subject && subject.primary_conditions && subject.primary_conditions.length > 0 ? (
                    subject.primary_conditions.map((entry, index) => (
                      <tr key={index}>
                        <td>{entry.code_value + ": " + entry.description}</td>
                        <td>{entry.approximate_date ? entry.approximate_date : "n/a"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2" className="text-center">
                        No Primary Conditions on Record.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Treatments Table (without header) */}
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="table-secondary">
                  <tr>
                    <th>CPT</th>
                    <th>Weeks Post Op</th>
                  </tr>
                </thead>
                <tbody>
                  {subject && subject.treatments && subject.treatments.length > 0 ? (
                    subject.treatments.map((entry, index) => (
                      <tr key={index}>
                        <td>{entry.code_value + ": " + entry.description + " (" + entry.sls_modifier + ")"}</td>
                        <td>{entry.weeks_post_op ? entry.weeks_post_op : "n/a"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2" className="text-center">
                        No Treatments on Record.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
